var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBanderaPeru(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.99 16.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 3555",
    d: "M0 0h23v16H0z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 3556",
    d: "M0 0h7.66v16H0z",
    fill: "#d60f2f"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 3557",
    d: "M15.32 0H23v16h-7.68z",
    fill: "#b8181b"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 3558",
    d: "M13.28 8.32c-.64-1-.06-1.48-.06-1.48l-.51-.54a1.65 1.65 0 01-1.22-.43 1.65 1.65 0 01-1.21.43l-.51.54s.58.5-.06 1.48c-.83 1.29 1.48 1.15 1.78 1.83.31-.68 2.62-.54 1.79-1.83z",
    fill: "#6fa449"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanderaPeru);
export default __webpack_public_path__ + "static/media/bandera-Peru.84562f5d.svg";
export { ForwardRef as ReactComponent };